import { generateUUID } from './uuid';
import { get, getOrSet } from './sessionStorage';
import { TrackingConfig } from './config';
import { trackQuotePrint, trackQuoteView } from './api';
document.addEventListener('DOMContentLoaded', () => {
  try {
    const trackingConfig = TrackingConfig.init();
    const [isTrackingEnabled, disabledReason] = trackingConfig.getIsTrackingEnabled();
    if (isTrackingEnabled) {
      const publicUrlKey = trackingConfig.publicUrlKey;
      const [sessionId, isNewSession] = getOrSet(getSessionIdKey(publicUrlKey), generateUUID());
      if (isNewSession) {
        trackQuoteView(trackingConfig.appBaseUrl, trackingConfig.portalId, {
          sessionId,
          publicUrlKey
        });
      }
      setupPrintEventListener(trackingConfig);
      console.log('hs-quote-tracking initialized', {
        isNewSession
      });
    } else {
      console.log('hs-quote-tracking disabled', {
        disabledReason
      });
    }
  } catch (error) {
    console.error('hs-quote-tracking failed to initialize', {
      error
    });
  }
});
function getSessionIdKey(publicUrlKey) {
  return `session-id-${publicUrlKey}`;
}
function setupPrintEventListener(trackingConfig) {
  window.addEventListener('beforeprint', () => {
    const sessionId = get(getSessionIdKey(trackingConfig.publicUrlKey));
    if (sessionId && trackingConfig.publicUrlKey) {
      trackQuotePrint(trackingConfig.appBaseUrl, trackingConfig.portalId, {
        sessionId,
        publicUrlKey: trackingConfig.publicUrlKey
      });
    }
  });
}